export default {
  namespaced: true,
  state: {
    shortcuts: []
  },
  mutations: {
    add(state, shortcuts) {
      const names = state.shortcuts.map(d => {
        return d.name;
      });
      for (let shortcut of shortcuts) {
        if(!names.find(d => d === shortcut.name))
          state.shortcuts.push(shortcut);
      }
    },
    clear(state) {
      state.shortcuts = [];
    }
  },
  actions: {
    clear({commit}) {
      commit('clear');
    },
    register({commit}, shortcuts) {
      commit('add', shortcuts);
    }
  }
}
